.ScrollShadowArea {
  mask-image:
    linear-gradient(black, black),
    linear-gradient(to bottom, black, transparent var(--shadow-top)),
    linear-gradient(to top, black, transparent var(--shadow-bottom)),
    linear-gradient(to right, black, transparent var(--shadow-left)),
    linear-gradient(to left, black, transparent var(--shadow-right));
  mask-size:
    calc(100% + 2px) calc(100% + 2px),
    100% var(--scroll-shadow-size),
    100% var(--scroll-shadow-size),
    var(--scroll-shadow-size) 100%,
    var(--scroll-shadow-size) 100%;
  mask-position:
    -1px -1px,
    top,
    bottom,
    left,
    right;
  mask-repeat: no-repeat;
  mask-composite: exclude;
}
